const createInstance = (optimizely) => {
  return {
    getExperimentById(experimentId) {
      if (!optimizely || !optimizely.get || !optimizely.get('state')) {
        return null;
      }

      const experimentsData = optimizely.get('state').getExperimentStates();

      if (!(experimentId in experimentsData)) {
        return null;
      }

      const {
        experimentName: name,
        id,
        isActive,
        variation
      } = experimentsData[experimentId];

      return {
        name,
        id,
        isActive,
        variation
      };
    }
  };
};

export const mockOptimizelyService = (experiments) => {
  const experimentData = experiments.reduce((hash, exp) => {
    hash[exp.id] = exp;
    return hash;
  }, {});

  return {
    getExperimentById: (id) => experimentData[id] || null
  };
};

export const isVariation = (optimizely, experimentId, variationId) => {
  const experiment = optimizely.getExperimentById(experimentId);
  const currentVariationId =
    experiment && experiment.variation ? experiment.variation.id : null;

  return currentVariationId === variationId;
};

export const optimizelyService = {
  create: createInstance
};
